export const certificatesData = [
  {
    id: 1,
    name: "Machine Learning Cohort",
    issuer: "Bangkit Academy - Dicoding",
    year: "2025",
    credentialUrl:
      "https://www.linkedin.com/in/riezqidr/overlay/1740847779936/single-media-viewer/?profileId=ACoAADY4fycBW4wrhaaL02P9kqJwNM8rvM8_FFk",
  },
  {
    id: 2,
    name: "Basic Visualization Data with Python",
    issuer: "Dicoding",
    year: "2024",
    credentialUrl: "https://www.dicoding.com/certificates/KEXL8272MZG2",
  },
  {
    id: 3,
    name: "IBM Data Science Specialization",
    issuer: "IBM - Coursera",
    year: "2024",
    credentialUrl:
      "https://www.coursera.org/account/accomplishments/specialization/SS8ZXBCPZQ8Q",
  },
  {
    id: 4,
    name: "Advanced Computer Vision with TensorFlow",
    issuer: "DeepLearning.AI - Coursera",
    year: "2024",
    credentialUrl:
      "https://www.coursera.org/account/accomplishments/verify/NGBU2NJF3XV3",
  },
  {
    id: 5,
    name: "Crash Course on Python",
    issuer: "Google - Coursera",
    year: "2024",
    credentialUrl:
      "https://www.coursera.org/account/accomplishments/verify/688KGLUXTS2N",
  },
  {
    id: 6,
    name: "Applied Machine Learning in Python",
    issuer: "Dicoding",
    year: "2025",
    credentialUrl: "https://www.dicoding.com/certificates/1OP827QVLPQK",
  },
];
